import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/user_long_task";

export class DownloadLongTaskResultCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor(taskID: string) {
        super();
        this.responseType = "blob";
        this.endPoint = this.endPoint + "/" + taskID;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand();
    }
}
